module.exports = __webpack_public_path__ + "es-w6Y.svg";